<div style="background-color: #fff; height: 100%; width: 100%; padding:20px; position:relative;">
  <h1 mat-dialog-title style="color:#000;">{{ 'Add New Info' | translate }}</h1>

  <button mat-icon-button (click)="onClose()" style="position: absolute; top: 10px; right: 10px; color: #000;">
    <mat-icon>close</mat-icon>
  </button>

  <div mat-dialog-content style="padding:20px;">
    <div *ngIf="isLoading" class="loading-overlay">
      <mat-spinner diameter="30"></mat-spinner>
    </div>

    <div>

      <div class="form-group">
        <label>{{ 'Date' | translate }}</label>
        <input value="{{selectedDate}}" (change)="changeDate($event)" type="date" class="form-control"/>
      </div>

    </div>

    <mat-tab-group style="margin-bottom: 20px;">
      <mat-tab *ngFor="let lang of availableLanguages" [label]="lang.toUpperCase()">
        <form [formGroup]="form[lang]">
          <div class="form-group">
            <label>{{ 'Title' | translate }}</label>
            <input formControlName="title" type="text" class="form-control"/>
          </div>

          <div class="form-group">
            <label>{{ 'Short Description' | translate }}</label>
            <textarea formControlName="short_description" rows="3" class="form-control"></textarea>
          </div>
        </form>
      </mat-tab>
    </mat-tab-group>

    <div class="image-container">
      <div class="form-group">
        <img src="{{smallImageFile}}" width="100%" *ngIf="smallImageFile" />
        <label>{{ 'Small Image' | translate }}</label>
        <input type="file" (change)="onFileChange($event, 'small')" accept="image/*" class="form-control"/>
      </div>

    </div>

    <div mat-dialog-actions style="justify-content: flex-end; padding-right:20px; margin-bottom:0; padding:20px;">
      <button
        mat-raised-button
        color="secondary"
        type="button"
        (click)="generateWithIa()"
      >
        {{ 'Generate Content with IA' | translate }}
      </button>

    </div>

    <div mat-dialog-actions style="justify-content: flex-end; padding-right:20px; margin-bottom:0; padding:20px;">
      <div class="form-group">
        <input type="checkbox" id="force" style="margin-right: 5px;" [(ngModel)]="force" (change)="setForceOrNot()" />
        <label for="force">{{ 'Force Resend Push Message' | translate }}</label>
      </div>
    </div>

    <div mat-dialog-actions style="justify-content: flex-end; padding-right:20px; margin-bottom:0; padding:20px;">
      <button
        *ngIf="id"
        mat-raised-button
        color="danger"
        type="button"
        (click)="deleteEvent()"
      >
        {{ 'Delete' | translate }}
      </button>

      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onSubmit()"
        [disabled]="!isFormValid()"
      >
        {{ 'Update' | translate }}
      </button>
    </div>

  </div>
</div>
